<template>
  <div class="grey-box-container" style="padding: 0;">

    <div class="grey-box-top">

      <div class="clearfix" v-if="initialAuction.status === auctionStatuses.DRAFT.value">
        <div class="col12 auction-draft">
          <strong>DRAFT</strong><br/>
          Auction is not publicly visible yet
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.OPEN.value">
        <div class="col12 registration-open">
          <strong>REGISTRATION OPEN</strong><br/>
          Submit required documentation for approval to bid
        </div>
        <div class="col12">
          <div class="countdown-timer"><v-icon>schedule</v-icon> {{ timeLeftToRegister | countdownTimer }}</div>
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.FREEZE.value">
        <div class="col12 auction-closed">
          <strong>REGISTRATION CLOSED</strong><br/>
          Auction will start soon
        </div>
        <div class="col12">
          <div class="countdown-timer"><v-icon>schedule</v-icon> {{ timeLeftToStart | countdownTimer }}</div>
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.AUCTION.value">
        <div class="col12 auction-extended" v-if="initialAuction.extended">
          <strong>BID EXTENDER ACTIVE</strong><br/>
          Closing period has extended
        </div>
        <div class="col12 auction-in-progress" v-else>
          <strong>IN AUCTION</strong><br/>
          Bid extender with late bids (5 mins)
        </div>
        <div class="col12">
          <div class="countdown-timer"><v-icon>schedule</v-icon> {{ timeLeftToBid | countdownTimer }}</div>
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.PROCESSING.value">
        <div class="col12 auction-closed">
          <strong>AUCTION ENDED</strong><br/>
          Execution of purchase agreement pending
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.IN_ESCROW.value">
        <div class="col12 auction-closed">
          <strong>IN ESCROW</strong><br/>
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.CLOSED.value">
        <div class="col12 auction-closed">
          <strong>AUCTION ENDED</strong><br/>
          No winner, reserve price not met
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.SOLD.value">
        <div class="col12 auction-sold">
          <strong>AUCTION ENDED</strong><br/>
          <span v-if="winner.alias">Winner: {{ winner.alias }}</span>
        </div>
      </div>

      <div class="clearfix" v-else-if="initialAuction.status === auctionStatuses.CANCELLED.value">
        <div class="col12 auction-cancelled">
          <strong>AUCTION CANCELLED</strong><br/>
        </div>
      </div>

      <div class="clearfix" v-else>
        <div class="col12 auction-closed">
          <strong>UNKNOWN STATUS</strong><br/>
          Status is {{ initialAuction.status | lowercase }}
        </div>
      </div>

    </div>

    <!--- ---><!--

      <v-progress-linear
        v-if="initialAuction.status === auctionStatuses.OPEN.value"
        :value="timeLeftToRegisterPercentage" height="2" color="blue darken-2" background-color="grey lighten-2" />

      <v-progress-linear
        v-if="initialAuction.status === auctionStatuses.FREEZE.value"
        :value="timeLeftToStartPercentage" height="2" color="blue darken-2" background-color="grey lighten-2" />

      <v-progress-linear
        v-if="initialAuction.status === auctionStatuses.AUCTION.value"
        :value="timeLeftToBidPercentage" height="2" color="brandgreen" background-color="grey lighten-2" />

      <v-progress-linear
        v-if="initialAuction.status === auctionStatuses.PROCESSING.value || initialAuction.status === auctionStatuses.IN_ESCROW.value || initialAuction.status === auctionStatuses.SOLD.value || initialAuction.status === auctionStatuses.CLOSED.value"
        :value="0" height="2" background-color="grey lighten-2" />

      --><!--- --->

    <div class="grey-box-middle">

      <div class="p clearfix" v-if="initialAuction.status === auctionStatuses.CANCELLED.value">
        <div v-html="$options.filters.convertLinebreaks(initialAuction.cancelReason)" />
      </div>

      <div class="p clearfix">
        <div class="col23">
          <h3>Auction Period</h3>
          {{ initialAuction.startDate | prettyDateTimeShort(initialAuction.metadata.timezone) }} -<br/>
          {{ initialAuction.endDate | prettyDateTimeShort(initialAuction.metadata.timezone) }}
        </div>
        <div class="col13">
          <!-- TODO add to calendar -->
        </div>
      </div>

      <div class="p clearfix">
        <div class="col510">
          <h3 v-if="initialAuction.status === auctionStatuses.DRAFT.value || initialAuction.status === auctionStatuses.OPEN.value">Starting Price</h3>
          <h3 v-else-if="initialAuction.status === auctionStatuses.AUCTION.value">Current Bid</h3>
          <h3 v-else>Highest bid</h3>

          <transition enter-active-class="animated bounce" mode="out-in">
            <div class="big" :key="initialAuction.startingPrice" v-if="initialAuction.status === auctionStatuses.DRAFT.value || initialAuction.status === auctionStatuses.OPEN.value || initialAuction.status === auctionStatuses.FREEZE.value">
              {{ initialAuction.startingPrice | prettyMoney }}
            </div>
            <div class="big in-auction" v-else-if="initialAuction.status === auctionStatuses.AUCTION.value">
              {{ currentPrice | prettyMoney }}
            </div>
            <div class="big" v-else>
              {{ initialAuction.currentPrice | prettyMoney }}
            </div>
          </transition>

          <div style="margin-top: 1em; line-height: 1em; color: #4a4a4a;">
            <div v-if="initialAuction.metadata.hideReservePrice !== true">Reserve price: {{ initialAuction.reservePrice | prettyMoney }}</div>
            <div>Increments: {{ initialAuction.minimumIncrement | prettyMoney }}</div>
          </div>
        </div>

        <div class="col210" v-if="authenticatedUser">
          <h3>Bids</h3>
          <div class="big pointer" @click="$store.commit('openBidsDialog', initialAuction.id)">{{ numberOfBids }}</div>
          <div style="margin-top: 1em; line-height: 1em; color: #4a4a4a;">
            Bidders: {{ numberOfBidders }}
          </div>
          <AuctionBids />
        </div>

        <div class="col310" v-if="authenticatedUser">
          <h3>Ranking</h3>
          <div class="ranking-list">
            <div v-for="(userId, index) in rankingList" :key="userId" :class="'ranking-list-' + index">
              {{ profileCache[userId] ? profileCache[userId].alias : '' | truncate(18) }}
            </div>
            <div v-if="currentBidsLoading"><InlineSpinner /></div>
            <div v-if="!currentBidsLoading && rankingList.length === 0">(No bidders)</div>
          </div>
        </div>
      </div>

      <!--- --->

      <!-- 0) draft (previewed by listing agent) -->
      <div v-if="initialAuction.status === auctionStatuses.DRAFT.value" style="text-align: center; margin: 2rem 0; color: #666;">
        <p><button disabled>Register to Bid</button></p>
        <div class="p">
          Check the list of required documents before registering.
          <v-popover style="display: inline-block; max-width: 5rem;">
            <v-icon small color="grey" style="cursor: pointer;">help</v-icon>
            <template slot="popover">
              <p><strong style="font-size: 1.2rem;">Required Documents</strong></p>
              <p>You need to upload the required documents in order for the seller to approve you as a registered bidder for the property.</p>
              <ul class="list-bullets" v-if="initialAuction.buyerRequirements">
                <li v-for="req in initialAuction.buyerRequirements" :key="req.id">{{ req.name }}</li>
              </ul>
            </template>
          </v-popover>
        </div>
      </div>

      <!-- 1) auction is open for registrations -->
      <div v-else-if="initialAuction.status === auctionStatuses.OPEN.value" style="text-align: center; margin: 2rem 0; color: #666;">

        <!-- 1a) not logged in, anonymous or entry role -->
        <div v-if="!authenticatedUser || (myRole === auctionRoles.ANONYMOUS.value || myRole === auctionRoles.ENTRY.value)">
          <p><button @click="registerToAuction">Register to Bid</button></p>
          <p v-if="!authenticatedUser">You need to be signed-in before you can register.</p>
          <div class="p">
            Check the list of required documents before registering.
            <v-popover style="display: inline-block; max-width: 5rem;">
              <v-icon small color="grey" style="cursor: pointer;">help</v-icon>
              <template slot="popover">
                <p><strong style="font-size: 1.2rem;">Required Documents</strong></p>
                <p>You need to upload the required documents in order for the seller to approve you as a registered bidder for the property.</p>
                <ul class="list-bullets" v-if="initialAuction.buyerRequirements">
                  <li v-for="req in initialAuction.buyerRequirements" :key="req.id">{{ req.name }}</li>
                </ul>
              </template>
            </v-popover>
          </div>
        </div>

        <!-- 1b) applicant (show view registration form button) -->
        <template v-else-if="authenticatedUser && myRole === auctionRoles.APPLICANT.value">
          <p><button class="btn-neutral" @click="openApplicationPage">Registration Pending for Approval</button></p>
          <div class="p">
            Your auction registration is being processed by the listing agent.
            You will be informed later whether you need to provide more information, or if the
            registration has been approved.
          </div>
        </template>

        <!-- 1c) disqualified (show view registration form button) -->
        <template v-else-if="authenticatedUser && myRole === auctionRoles.DISQUALIFIED.value">
          <p><button class="btn-neutral" @click="openApplicationPage">See Registration Details</button></p>
          <p>Unfortunately your registration to this auction has been rejected.</p>
        </template>

        <!-- 1d) approved buyer -->
        <template v-else-if="authenticatedUser && myRole === auctionRoles.BUYER.value">
          <p v-if="this.$props.disableLinks"><button class="btn-neutral">See Registration Details</button></p>
          <p v-else><button class="btn-neutral" @click="openApplicationPage">See Registration Details</button></p>
          <p>Congratulations, you've been approved as a bidder in this auction.</p>
        </template>

        <!-- 1e) others (agents, admins) -->
        <div v-else>
          <p><button disabled>Register to Bid</button></p>
          <p>You cannot register to this auction because of your role.<br/>(e.g. agent or admin of this company)</p>
        </div>

      </div>

      <!-- 2) auction is in progress -->
      <template v-else-if="initialAuction.status === auctionStatuses.AUCTION.value">

        <!-- 2a) buyer -->
        <div v-if="myRole === auctionRoles.BUYER.value" style="text-align: center; margin: 2rem 0; color: #666;">
          <form ref="bidForm" @submit.prevent>
            <currency-input id="yourBid" v-model="yourBid" :disabled="processing" inputStyle="width: 40%; display: inline; text-align: center; color: #000;" />
            <button slot="activator" @click.stop="confirmBid()" :disabled="processing" style="width: 30%; padding: .8rem;">
              Place a bid
            </button>
          </form>
          <div style="margin: 1rem 0 1.5rem 0; color: #666;">
            My last bid: {{ myLastBid | prettyMoney }} {{ myRanking }}
          </div>

          <v-dialog v-model="bidDialog" max-width="420px">
            <div style="position: relative; background-color: #fff; text-align: center;">
              <v-icon style="cursor: pointer; position: absolute; right: 0; top: 0; padding: 0.5rem;" @click.stop="bidDialog = false">close</v-icon>
              <div style="padding: 3rem;">
                <div style="font-size: 1.5rem;">You are about to Bid for</div>
                <div style="font-size: 2rem; font-family: 'Encode Sans', sans-serif; line-height: 1em; margin-bottom: 2rem;">
                  {{ yourBid | prettyMoney }}
                </div>
                <div style="margin-bottom: 2rem;"><button class="wider" @click="sendBid()">Confirm</button></div>
                <p v-if="autoBidAllowed">Set automatics bids with <a @click="openAutoBid()">autobid</a></p>
              </div>
            </div>
          </v-dialog>
        </div>

        <!-- 2b) others -->
        <div v-else style="margin: 1rem 0;">
          You are not eligible to bid in this auction.
        </div>

      </template>

    </div>

    <div class="grey-box-bottom-buttons clearfix align-center">
      <div class="col12 watchlist pointer" @click="toggleWatchlist">
        <div v-if="watchlisted"><img :src="require('../assets/watchlist-true.png')" /> Watchlisted</div>
        <div v-else><img :src="require('../assets/watchlist-false.png')" /> Add to Watchlist</div>
      </div>
      <template v-if="initialAuction.status === auctionStatuses.OPEN.value || initialAuction.status === auctionStatuses.FREEZE.value ||initialAuction.status === auctionStatuses.AUCTION.value">
        <div class="col12 pointer">
          <AutoBidWidget :initialAuction="initialAuction" />
        </div>
      </template>
    </div>

  </div>
</template>

<script>
  import ordinal from 'ordinal'
  import { mapGetters, mapMutations } from 'vuex'
  import { auctionRoles, auctionTypeLabel, auctionStatuses } from '../utils/PfxUtils.js'
  import AuctionBids from './AuctionBids.vue'
  import AutoBidWidget from './elements/AutoBidWidget.vue'
  import InlineSpinner from './elements/InlineSpinner.vue'
  import CurrencyInput from './elements/CurrencyInput.vue'

  let intervalTimer = null

  export default {
    components: {
      AuctionBids,
      AutoBidWidget,
      InlineSpinner,
      CurrencyInput
    },
    props: {
      initialAuction: {
        type: Object,
        required: true
      },
      disableLinks: {
          type: Boolean,
          required: false,
          default: false
      }
    },
    data() {
      return {
        timeLeftToRegister: 0,
        timeLeftToRegisterPercentage: 0,
        timeLeftToStart: 0,
        timeLeftToStartPercentage: 0,
        timeLeftToBid: 0,
        timeLeftToBidPercentage: 0,

        currentBids: [],
        currentBidsLoading: true,
        profileCache: {},

        processingBid: false,
        yourBid: '',
        bidDialog: false,
        errorMessage: ''
      }
    },
    computed: {
      ...mapGetters([
        'authenticatedUser',
        'subdomain',
        'autoBidAllowed',
        'getWatchlist'
      ]),
      myRole() {
        return this.initialAuction.role.role || auctionRoles.ANONYMOUS.value
      },
      currentPrice() {
        const latestBid = (this.currentBids && this.currentBids.length > 0) ? this.currentBids[0].amount : 0
        return Math.max(this.initialAuction.startingPrice, this.initialAuction.currentPrice, latestBid)
      },
      numberOfBids() {
        return this.currentBids.length
      },
      numberOfBidders() {
        let bidders = []
        this.currentBids.forEach(bid => {
          if (bidders.indexOf(bid.userId) === -1) {
            bidders.push(bid.userId)
          }
        })
        return bidders.length
      },
      processing() {
        return this.processingBid
      },
      auctionRoles() {
        return auctionRoles
      },
      auctionStatuses() {
        return auctionStatuses
      },
      myLastBid() {
        let myLastBid = 0
        this.currentBids.forEach(bid => {
          if (myLastBid) return
          if (bid.userId === this.$store.state.user.cognitoSubject) {
            myLastBid = bid.amount
          }
        })
        return myLastBid
      },
      myRanking() {
        let r = 0
        let index = 0
        this.currentBids.forEach(bid => {
          if (r) return
          index++
          if (bid.userId === this.$store.state.user.cognitoSubject) {
            r = index
          }
        })
        return r ? '(' + ordinal(r) + ' place)' : ''
      },
      rankingList() {
        if (this.currentBidsLoading) return []
        const rankingList = []
        this.currentBids.forEach(bid => {
          if (rankingList.length === 3) return
          if (rankingList.indexOf(bid.userId) === -1) {
            rankingList.push(bid.userId)
          }
        })
        return rankingList
      },
      winner() {
        const ranking = this.rankingList
        if (ranking.length > 0) {
          const winnerUserId = ranking[0]
          return this.profileCache[winnerUserId]
        }
        return {}
      },
      watchlisted() {
        return this.getWatchlist.indexOf(this.initialAuction.id) !== -1
      }
    },
    created() {
      intervalTimer = setInterval(this.timerTasks, 1000)
      this.refreshBids()
    },
    mounted() {
      this.fetchCurrentBids()
      this.focusBidInput()

      // subscribe to auction events
      this.$events.on('auction', auction => {
        if (auction.id === this.initialAuction.id) {
          this.fetchCurrentBids()
        }
      })
    },
    beforeDestroy() {
      this.$events.off('auction')
    },
    destroyed() {
      if (intervalTimer) {
        console.log('clearInterval...')
        clearInterval(intervalTimer)
      }
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner',
        'showAutoBidDialog'
      ]),
      auctionTypeLabel,

      timerTasks() {
        const cd = this.$PfxUtils.currentDate()

        this.timeLeftToRegister = Math.floor((this.initialAuction.freezeDate - cd.getTime()) / 1000)

        let max = this.initialAuction.freezeDate - this.initialAuction.publishDate
        let now = max - (this.initialAuction.freezeDate - cd.getTime())
        this.timeLeftToRegisterPercentage = parseFloat(now / max) * 100

        this.timeLeftToStart = Math.floor((this.initialAuction.startDate - cd.getTime()) / 1000)

        max = this.initialAuction.startDate - this.initialAuction.freezeDate
        now = max - (this.initialAuction.startDate - cd.getTime())
        this.timeLeftToStartPercentage = parseFloat(now / max) * 100

        this.timeLeftToBid = Math.floor((this.initialAuction.endDate - cd.getTime()) / 1000)

        max = this.initialAuction.endDate - this.initialAuction.startDate
        now = max - (this.initialAuction.endDate - cd.getTime())
        this.timeLeftToBidPercentage = parseFloat(now / max) * 100
      },

      registerToAuction() {
        if (this.myRole === auctionRoles.ANONYMOUS.value ||
          this.myRole === auctionRoles.DISQUALIFIED.value ||
          this.myRole === 'TENANT_AGENT' ||
          this.myRole === 'TENANT_ADMIN') { // => register i.e. create new row to auction_role (role = entry)
          this.setLoadingSpinner(true)
          this.$PfxBackendApi.postAuctionRegister(this.initialAuction.tenant.subdomain, this.initialAuction.id).then(res => {
            console.log('postAuctionRegister res', res) // res.data = { id: 6, role: 'ENTRY', userId: 'xxxxxxxx-xxxx-xxxx-xxxxxxxxxxxx' }
            this.$router.push('/auction/' + this.initialAuction.id + '/register')
          }).catch(err => {
            this.$notify({type: err.status === 418 ? 'info' : 'danger', message: err.data.message || JSON.stringify(err.data)})
          }).then(() => {
            this.setLoadingSpinner(false)
          })

        } else if (this.myRole === auctionRoles.ENTRY.value || this.myRole === auctionRoles.APPLICANT.value) { // => update registration i.e. user has already clicking registration once and now returns
          this.$router.push('/auction/' + this.initialAuction.id + '/register')

        } else {
          this.$notify({type: 'danger', message: 'Unexpected user role: ' + this.myRole})
        }
      },

      openApplicationPage() {
        this.$router.push('/application/' + this.initialAuction.id  + '/' + this.initialAuction.role.id)
      },

      focusBidInput() {
        const e = document.getElementById('yourBid')
        if (e) { e.focus() }
      },

      toggleWatchlist() {
        this.$store.dispatch('toggleWatchlistStatus', this.initialAuction.id)
      },

      confirmBid() {
        if (!this.$refs.bidForm.checkValidity()) {
          this.$refs.bidForm.reportValidity()
          return
        }
        this.bidDialog = true
      },

      sendBid() {
        this.processingBid = true
        this.errorMessage = ''

        const subdomain = this.subdomain
        const auctionId = this.initialAuction.id
        const amount = this.yourBid
        const formattedAmount = this.$options.filters.prettyMoney(amount)
        this.$PfxBackendApi
          .postBid(subdomain, auctionId, amount)
          .then(() => {
            this.$notify({type: 'success', message: 'You have bid for ' + formattedAmount})
            this.yourBid = ''
            this.processingBid = false
            this.focusBidInput()
          })
          .catch(err => {
            this.errorMessage = err.data.message || ''
            this.$notify({type: 'danger', title: 'Bid failed!', message: this.errorMessage})
            this.processingBid = false
            this.focusBidInput()
          })
          .then(() => {
            this.bidDialog = false
          })
      },

      openAutoBid() {
        this.bidDialog = false
        this.showAutoBidDialog(true)
      },

      fetchCurrentBids() {
        if ( !this.authenticatedUser || this.initialAuction.id < 1 ) {
          this.currentBidsLoading = false
          return // This is to suppress error message on preview
        }
        this.currentBidsLoading = true
        this.$PfxBackendApi.getBidsForAuction(this.initialAuction.tenant.subdomain, this.initialAuction.id).then(res => {
          console.info('getBidsForAuction res', res)
          let currentBids = res.data || []
          this.currentBidsLoading = currentBids.length
          currentBids.sort((a,b) => a.amount < b.amount ? 1 : a.amount === b.amount ? 0 : -1)
          currentBids.forEach(bid => {
            if (this.profileCache[bid.userId] === undefined) {
              this.profileCache[bid.userId] = { alias: '' }
              this.$PfxBackendApi.getUser(bid.userId).then(res => {
                console.debug('getUser res', res)
                this.profileCache[bid.userId] = res.data || {}
              }).catch(err => {
                console.error('getUser err', err)
              }).then(() => this.currentBidsLoading--)
            } else {
              this.currentBidsLoading--
            }
          })
          this.currentBids = currentBids

          // calculate next possible bid
          if (currentBids.length === 0) {
            this.yourBid = this.initialAuction.startingPrice
          } else {
            this.yourBid = currentBids[0].amount + this.initialAuction.minimumIncrement
          }

        }).catch(err => {
          console.error('getBidsForAuction err', err)
          this.$notify({ type: 'danger', message: 'Cannot get current bids' })
          this.currentBidsLoading = false
        })
      },

      refreshBids(){
          this.fetchCurrentBids()
          setTimeout(this.refreshBids, 60000)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .col12 { @include column(1/2, $gutter: 0); }
  .col13 { @include column(1/3); }
  .col23 { @include column(2/3); }
  .col510 { @include column(5/10); }
  .col210 { @include column(2/10); }
  .col310 { @include column(3/10); }

  h3 { font-size: 1em; font-weight: 600; margin: 0 0 1em; }

  .grey-box-top {
    position: relative;
    border-bottom: 2px solid $grey-box-lines;
    strong { font-weight: 600; }
  }
  .grey-box-middle {
    margin-top: 1rem;
    padding: 0 1rem;
    line-height: 1em;

    button {
      padding: 1.25rem;
      width: 75%;
    }
  }
  .grey-box-bottom-buttons {
    border-top: 2px solid $grey-box-lines;
    .col12 {
      padding: 1rem;
    }
    .col12.pointer {
      &:hover {
        background-color: $grey-box-hover;
      }
    }
    .col12:first-child {
      border-right: 2px solid $grey-box-lines;
    }
  }

  .auction-draft, .registration-open, .auction-in-progress, .auction-extended, .auction-sold, .auction-cancelled, .auction-closed {
    padding: 1rem;
    line-height: 1em;
  }
  .auction-draft {
    background-color: #EEEAE7; color: #333;
  }
  .registration-open {
    background-color: $color-auction-open; color: #333;
  }
  .auction-in-progress {
    background-color: $color-in-auction; color: #333;
  }
  .auction-extended {
    background-color: $color-extended; color: #333;
  }
  .auction-sold {
    background-color: #402A27; color: $color-white;
  }
  .auction-cancelled {
    background-color: #777; color: $color-white;
  }
  .auction-closed {
    background-color: #EEEAE7; color: #333;
  }

  .countdown-timer {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50%;
    text-align: center;

    font-family: 'Encode Sans', sans-serif;
    font-weight: 300;
    font-size: 1.1rem;

    .icon {
      margin-right: .5rem;
    }
  }

  .data-label {
  }
  .big {
    font-family: 'Encode Sans', sans-serif;
    font-size: 1.8em;
    font-weight: 300;
    line-height: 1em;
    margin-top: 0.2em;
  }
  .big.in-auction {
    color: #000;
  }

  .ranking-list {
    font-size: 12px;
    font-weight: 300;
    line-height: 1.25em;
    color: #666;
  }
  .ranking-list-0 {
    color: #000;
    font-weight: 600;
  }

  .watchlist {
    img {
      vertical-align: middle;
      margin-right: .5rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AuctionRegisterWidget.vue